export default __webpack_public_path__ + "static/media/before-you-start.4eb6d78b.svg";